import ProductListContainer from "../../../../Components/Applications/Ecommerce/ProductList/ProductListContainer";

const ProductList = () => {
  return <ProductListContainer />;
};

export default ProductList;
